import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React from 'react';
import { ColorSwatch } from '../../ColorSwatch/ColorSwatch.js';
import useStyles from './Swatches.styles.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

function Swatches(_a) {
  var _b = _a,
      data = _b.data,
      _b$swatchesPerRow = _b.swatchesPerRow,
      swatchesPerRow = _b$swatchesPerRow === void 0 ? 10 : _b$swatchesPerRow,
      _b$focusable = _b.focusable,
      focusable = _b$focusable === void 0 ? true : _b$focusable,
      classNames = _b.classNames,
      styles = _b.styles,
      _b$__staticSelector = _b.__staticSelector,
      __staticSelector = _b$__staticSelector === void 0 ? "color-picker" : _b$__staticSelector,
      unstyled = _b.unstyled,
      setValue = _b.setValue,
      onChangeEnd = _b.onChangeEnd,
      variant = _b.variant,
      size = _b.size,
      others = __objRest(_b, ["data", "swatchesPerRow", "focusable", "classNames", "styles", "__staticSelector", "unstyled", "setValue", "onChangeEnd", "variant", "size"]);

  var _useStyles = useStyles({
    swatchesPerRow
  }, {
    classNames,
    styles,
    name: __staticSelector,
    unstyled,
    variant,
    size
  }),
      classes = _useStyles.classes;

  var colors = data.map(function (color, index) {
    return /* @__PURE__ */React.createElement(ColorSwatch, {
      className: classes.swatch,
      component: "button",
      type: "button",
      color,
      key: index,
      radius: "sm",
      onClick: function onClick() {
        setValue(color);
        onChangeEnd == null ? void 0 : onChangeEnd(color);
      },
      style: {
        cursor: "pointer"
      },
      "aria-label": color,
      tabIndex: focusable ? 0 : -1
    });
  });
  return /* @__PURE__ */React.createElement("div", __spreadValues({
    className: classes.swatches
  }, others), colors);
}

Swatches.displayName = "@mantine/core/Swatches";
export { Swatches };